import React, { createContext, useContext, useState, useMemo } from "react";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { createAppTheme } from "./theme";

const ThemeCtx = createContext({ variant: "black", toggleTheme: () => {} });

export const useThemeVariant = () => useContext(ThemeCtx);

export const AppThemeProvider = ({ children }) => {
  const [variant, setVariant] = useState(
    () => localStorage.getItem("theme_variant") || "black"
  );

  const toggleTheme = () => {
    setVariant((v) => {
      const next = v === "navy" ? "black" : "navy";
      localStorage.setItem("theme_variant", next);
      return next;
    });
  };

  const theme = useMemo(() => createAppTheme(variant), [variant]);

  return (
    <ThemeCtx.Provider value={{ variant, toggleTheme }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ThemeCtx.Provider>
  );
};
